import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
const CentersActions = importer('Stores/Centers/Actions')
const { downloadAppointmentReport, downloadPotentialDonorsReport } = importer('APIs/centers', null)
const { tokens } = importer('Stores/Users/Select', null)
export default function * main ({
  reportType,
  fromDateTime,
  toDateTime,
  centerSfid,
  appointmentType,
  fileType,
  limit,
  page
}) {
  try {
    const _tokens = yield select(tokens)
    const { token_type, id_token } = _tokens
    const token = `${token_type} ${id_token}`
    yield put(CentersActions.downloadReportLoading())

    let res;
    if (reportType == 'potentialDonorsReport') {
      res = yield downloadPotentialDonorsReport(fromDateTime, toDateTime, centerSfid, appointmentType, fileType, limit, page, token)
    } else {
      res = yield yield downloadAppointmentReport(fromDateTime, toDateTime, centerSfid, appointmentType, fileType, limit, page, token)
    }

    yield put(CentersActions.downloadReportSuccess(res, fileType))
  } catch (error) {
    yield put(CentersActions.downloadReportFailure(error))
  }
}
